module.exports = __webpack_public_path__ + "img/kempervenne.9c42fcd7.jpg";